import { defineStore } from 'pinia'
import { type Ref, ref } from 'vue'
import type { Contract, ProductSubType, ShurContract } from 'shur-api'
import {
  fetchCoverageConceptPDFByContractId,
  fetchShurContractByPolicyId,
  fetchShurContractDetailsByPolicyId
} from '@/stores/shurService'

async function getCoverageConceptPDFByContractId(
  contractId: string,
  coverageConceptType: string,
  shurSubLine: ProductSubType,
  productVersion?: string
) {
  return await fetchCoverageConceptPDFByContractId(
    contractId,
    coverageConceptType,
    shurSubLine,
    productVersion
  )
}

export const useShurStore = defineStore('shur', () => {
  // only store internal values
  const shurContractsByPolicyId: Ref<Map<string, ShurContract>> = ref(
    new Map<string, ShurContract>()
  )
  const shurDetailContractsByPolicyId: Ref<Map<string, Contract>> = ref(
    new Map<string, Contract>()
  )

  async function getShurContractByPolicyId(
    policyId: string
  ): Promise<ShurContract | null> {
    let shurContract = shurContractsByPolicyId.value.get(policyId) ?? null
    if (!shurContract) {
      shurContract = await fetchShurContractByPolicyId(policyId)
      if (!shurContract) return null
      shurContractsByPolicyId.value.set(policyId, shurContract)
    }
    return shurContract
  }

  async function getShurContractDetailsByPolicyId(
    policyId: string,
    productSubType: ProductSubType | undefined
  ) {
    let shurDetailsContract = shurDetailContractsByPolicyId.value.get(policyId) ?? null
    if (!shurDetailsContract) {
      shurDetailsContract = await fetchShurContractDetailsByPolicyId(
        policyId,
        productSubType
      )
      if (!shurDetailsContract) return null
      shurDetailContractsByPolicyId.value.set(policyId, shurDetailsContract)
    }
    return shurDetailsContract
  }

  return {
    getCoverageConceptPDFByContractId,
    getShurContractByPolicyId,
    getShurContractDetailsByPolicyId
  }
})
